import { Page } from '@betty/navigation';
import { Registration } from '../components';
import { Box } from '@betty/moonlight';

function RegistrationPage() {
  return (
    <Page>
      <Box flex={1} backgroundColor="screenBackground">
        <Registration />
      </Box>
    </Page>
  );
}

export default RegistrationPage;
